import { compose, branch } from 'recompose'
import { createSelector } from 'reselect'
import { connect } from 'react-redux'
import orderBy from 'lodash/orderBy'

import { getListState } from 'data'
import { getAllNotes } from 'data/notes/selectors'
import {
  fetchesNoteChildrenNotes,
  fetchesChannelChildrenNotes,
  getListName,
} from './dataSync'

function makeMapStateToProps() {
  const getChannelNotes = createSelector(
    (_, channelId) => channelId,
    (_, channelId, orderField) => orderField,
    getAllNotes,
    (channelId, orderField, allNotes) => {
      return orderBy(
        allNotes
          .filter(
            note => note.get('channelId') === channelId && !note.archivedAt
          )
          .toArray(),
        orderField,
        'desc'
      )
    }
  )

  const getChildrenNotes = createSelector(
    (_, noteId) => noteId,
    (_, noteId, orderField) => orderField,
    getAllNotes,
    (noteId, orderField, allNotes) => {
      return orderBy(
        allNotes
          .filter(
            note =>
              note.parentNote &&
              note.parentNote.get('id') === noteId &&
              !note.archivedAt
          )
          .toArray(),
        orderField,
        'desc'
      )
    }
  )

  return function mapStateToProps(state, { channelId, noteId, orderField }) {
    const id = noteId || channelId
    const listName = getListName({ id })
    const listState = getListState(listName)(state)
    return {
      id,
      childrenNotes: Boolean(noteId)
        ? getChildrenNotes(state, noteId, orderField)
        : getChannelNotes(state, channelId, orderField),
      listState,
    }
  }
}

export default compose(
  branch(
    props => Boolean(props.noteId),
    fetchesNoteChildrenNotes,
    fetchesChannelChildrenNotes
  ),
  connect(makeMapStateToProps)
)
